module.exports = __webpack_public_path__ + "static/Coaching-4e375a76575503e3e86e872d2038b967.jpg";